module.exports = __webpack_public_path__ + "img/other-trainings.fc73208a.svg";